import ES from './es';
import EN from './en';

const cards = {
    ES,
    EN
};

export default cards;
